module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/avatarPlayer-7ece4b13f3d23a17d6d8b3004e22647f.svg";